<h2 mat-dialog-title>{{ data.title || "Visor de JSON" }}</h2>

<mat-dialog-content class="mat-typography">
  <pre class="json-container">{{ data.jsonData | json }}</pre>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
